import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CompanycategoryService } from 'src/app/Common/CompanyCategoryService/companycategory.service';

@Component({
  selector: 'app-sub-category-selector',
  templateUrl: './sub-category-selector.component.html',
  styleUrls: ['./sub-category-selector.component.css']
})
export class SubCategorySelectorComponent implements OnInit{


  ngOnInit(): void {
   
  }

  
  @Input({ required: true }) control!:FormControl
  companyCategoryService = inject(CompanycategoryService)
}
